import axios from '../../config/axios.js'
import { addIso690 } from '../../custom/function.js'


const STATE = {

    search_results: [],

}

const GETTERS = {

    search_results: state => state.search_results,

}

const MUTATIONS = {

    getSearchResults(state, docs) {
        state.search_results = docs
    },

}

const ACTIONS = {

    async searchDocuments({ commit }, query) {
        await axios.ACCESS.post('/api/bt/document/search', query)
            .then(res => {
                // console.log('search/searchDocuments', res)
                if (res.data.result) {
                    addIso690(res.data.documents)
                        .then(res => {
                            res.forEach(doc => Object.keys(doc).forEach(k => doc[k] = doc[k] == 'null' ? 'n.r.' : doc[k]))
                            commit('getSearchResults', res)
                        })
                } else { throw new Error(res.data) }
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/search.js